import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ModalModel } from '../../models/core/modal.model';
@Component({
  selector: 'ben-card-with-modal',
  templateUrl: './card-with-modal.component.html',
  styleUrls: ['./card-with-modal.component.scss']
})

export class CardWithModalComponent {
  @Input() listModalInfos: ModalModel[] = new Array<ModalModel>();
  @Input() cardTitle: string = "";
  @Input() cardSubTitle: string = "";
  @Input() cardIcon: string = "";
  @Input() cardDescription: string = "";
  @Input() buttonText: string = "";
  @Output() buttonClickedEvent = new EventEmitter<string>();


  buttonClick(event: string) {
    this.buttonClickedEvent.emit(event);
  }

}
